import type { ISerialize } from '@/objects/ISerialize';
import { ProductionEventCategory } from './ProductionEventCategory';

export class ProductionEventRace implements ISerialize {
    public ID: number;

    public Categories: ProductionEventCategory[];

    public Name: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ID?: number; Categories?: ProductionEventCategory[]; Name?: string | null }) {
        this.ID = values.ID ?? 0;

        this.Categories = values.Categories ?? [];

        this.Name = values.Name ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"Categories": [ ${this.Categories.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ProductionEventRace from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { ID?: number; Categories?: ProductionEventCategory[]; Name?: string | null }): ProductionEventRace {
        return new ProductionEventRace(values);
    }

    public static _FromServerJson(json: any): ProductionEventRace {
        return new ProductionEventRace({
            ID: json.ID,
            Categories: json.Categories?.map((x: any) => ProductionEventCategory._FromServerJson(x)),
            Name: json.Name ?? '',
        });
    }

    /**
     * Creates an instance of ProductionEventRace from another instance of ProductionEventRace.
     * @param other The ProductionEventRace you want to clone
     * @returns A cloned ProductionEventRace
     */
    public static FromOther(other: ProductionEventRace): ProductionEventRace {
        return ProductionEventRace._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ProductionEventRace.FromOther(this);
    }

    static NAME_OF_CLASS = 'ProductionEventRace';
}
